import React, {Component} from "react";

class Slogan extends Component {
    render() {
        return (
            <div className="slogan">
                <h1>Webcast. Never the Same.</h1>
                <p>Watch NUS webcast together, FASTER, with Danmaku*</p>
                <p>Try now on this page. Using your NUSNET ID to login via IVLE below</p>
                <small>* aka Annotations, 弹幕, <a target="_blank" href="/about">more info</a></small>
            </div>
        );
    }
}
export default Slogan;


// WEBPACK FOOTER //
// ./src/componentsBody/Slogan.js